;(function($, undefined){
    "use strict";

    var rnn = window.rnn;

    function adjustCols(parentEl, maxListItems, extendDropdown){

        // essentially the logic here ensures that there is never more than maxlistItems LI items 
        // in a UL. if there is, we want to create a new UL and append it after the first.
        // just keep going through them all until we have finished them.

        var $initialContainer = $(parentEl).find('ul.columns'),
            $columnItems = $(parentEl).find('ul.columns li').detach();

        for (var i = 0; i < $columnItems.length; i++) { 
            if (i % maxListItems === 0) {
                // making a new col.
                var $newCol = $initialContainer.clone().empty();
                $initialContainer.parent().append($newCol);
            }

            var $currentContainer = $(parentEl).find('ul.columns').last(),
                currentItem = $columnItems[i];

            $currentContainer.append(currentItem);
        }

        // destroy any empty cols.
        $(parentEl).find('ul.columns').each(function() {
            if($(this).children().length === 0){
                $(this).remove();
            }
        });

        if(extendDropdown === 'true'){
            if($(parentEl).find('ul.columns').length > 1){
                if($(parentEl).parent().parent().is("#weather_localities")){
                    $(parentEl).parent().addClass('extended')
                }else{
                    var numberOfCols = $(parentEl).find('ul.columns').length,
                        colWidth = $(parentEl).find('ul.columns').width(),
                        totalColWidth = numberOfCols * colWidth,
                        colMargin = parseInt($(parentEl).find('ul.columns').css('margin-right')),
                        totalMargin = colMargin * numberOfCols,
                        dropdownWidth = totalColWidth + totalMargin;

                    $(parentEl).parent().width(dropdownWidth);
                }
            }
        }
    }

    function topHatCols(){
        $('.adjust-list').each(function() {
            adjustCols(this, this.getAttribute('data-max-items'), this.getAttribute('data-extend'));
        });
    }

    function checkNav(){
        // we want to hide the nav element if it's empty.
        if ($('nav.sitenav').children().length === 0){
            $('nav.sitenav').hide();
        }
    }

    function initHeader(){
        topHatCols();
        checkNav();
    }

    rnn.modules.register("header", {
        init: initHeader
    });

})(jQuery);
